// extracted by mini-css-extract-plugin
module.exports = {"image-block":"ImageBlock_image-block__d7g8t","imageBlock":"ImageBlock_image-block__d7g8t","no-margins":"ImageBlock_no-margins__mKOcx","noMargins":"ImageBlock_no-margins__mKOcx"};